import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InputSelect from '../../Forms/InputSelect.jsx';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider.jsx';
import Requestrow from './Requestrow.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import ExcelExportButton from '../../assets/ExcelExportButton.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Requests = () => { 
  const { SetNotification } = useStateContext();
  const [requests, setRequests] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [requestsPerPage, setRequestsPerPage] = useState(10);
  const [emailFilter, setEmailFilter] = useState('');
  const [selectedPosition, setSelectedPosition] = useState('');
  const [selectedNationality, setSelectedNationality] = useState('');
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
  const abortController = new AbortController(); 

  useEffect(() => {
    const fetchData = async () => {
      if (!conferenceId) return; // Don't fetch if conferenceId is not set

      setLoading(true); // Set loading to true while fetching data
      try {
        const response = await AxiosClient.get(`/Registeration/${conferenceId}` ,  {
          signal: abortController.signal 
        });
        const { users } = await response.data;
        setRequests(users);
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error fetching data:', error);
        }
        setLoading(false); // Ensure loading is turned off in case of an error
      }
    };

    fetchData();


    return () => {
      abortController.abort(); // Cleanup on component unmount or if conferenceId changes
    };
  }, [conferenceId]);

  const filterRequests = () => {
    let filteredRequests = requests;
    // Filter by email
    if (emailFilter.trim() !== '') {
      filteredRequests = filteredRequests.filter(request =>
        request.email.toLowerCase().includes(emailFilter.trim().toLowerCase())
      );
    }

    // Filter by position
    if (selectedPosition) {
      filteredRequests = filteredRequests.filter(request =>
        request.position.toLowerCase() === selectedPosition.toLowerCase()
      );
    }

    // Filter by nationality
    if (selectedNationality) {
      filteredRequests = filteredRequests.filter(request =>
        request.nationality.toLowerCase() === selectedNationality.toLowerCase()
      );
    }

    return filteredRequests;
  };

  const indexOfLastRequest = currentPage * requestsPerPage;
  const indexOfFirstRequest = indexOfLastRequest - requestsPerPage;
  const currentRequests = filterRequests().slice(indexOfFirstRequest, indexOfLastRequest);
  const ExeilData = filterRequests(); 
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  console.log(requests) ; 

  return (
    <section className="p-4">
      {loading ? (
        <div className="card border-0 shadow-sm rounded-4 p-4">
          <Loader label="Loading requests..." />
        </div>
      ) : (
        <>
          <div className="card border-0 shadow-sm rounded-4 p-3 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-lg-4 col-md-6">
                <label className="form-label fw-semibold">Search by email</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Filter by email"
                  value={emailFilter}
                  onChange={(e) => setEmailFilter(e.target.value)}
                />
              </div>

              <div className="col-lg-4 col-md-6">
                <InputSelect
                  title={"Filter by position"}
                  array={[...new Set(requests.map((item) => item.position))]}
                  val={selectedPosition}
                  setval={setSelectedPosition}
                />
              </div>

              <div className="col-lg-4 col-md-6">
                <InputSelect
                  title={"Filter by nationality"}
                  array={[...new Set(requests.map((item) => item.nationality))]}
                  val={selectedNationality}
                  setval={setSelectedNationality}
                />
              </div>
            </div>

            <div className="dashboard-actions mt-3">
              <button className="btn btn-outline-primary" onClick={() => setShowFilter('Filtered')}>
                Filtered requests
              </button>
              <button className="btn btn-outline-secondary" onClick={() => setShowFilter(null)}>
                Show all
              </button>
              <ExcelExportButton data={requests} fileName="requests" label="Export all" />
              <ExcelExportButton data={ExeilData} fileName="filtered_requests" label={"Export filtered"} />
            </div>
          </div>

          <div className="card border-0 shadow-sm rounded-4 p-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="ps-4">Image</th>
                    <th>Full Name</th>
                    <th>Position</th>
                    <th>Nationality</th>
                    <th>Type</th>
                    <th className="pe-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRequests.length > 0 ? (
                    currentRequests.map((request) => <Requestrow key={request.id} req={request} />)
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4 text-muted">No requests found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="pagination p-3">
              {requests.length > requestsPerPage && (
                <ul className="pagination mb-0">
                  {Array(Math.ceil(requests.length / requestsPerPage))
                    .fill()
                    .map((_, index) => (
                      <li key={index} className="page-item">
                        <button className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}
                </ul>
              )}
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Requests;
